export const DEFAULT_THEME_STATE_CHANGE = "DEFAULT_THEME_STATE_CHANGE";
export const CHANGE_SELECT_LANGUAGE = "CHANGE_SELECT_LANGUAGE";
export const USER_CHAT_LIST = "USER_CHAT_LIST";
export const XMPP_CLIENT = "XMPP_CLIENT";
export const CHAT_HISTORY = "CHAT_HISTORY";
export const CHAT_MSG = "CHAT_MSG";
export const AIRPORT_LIST = "AIRPORT_LIST";
